export function makeId(): string {
  // Prefer browser-native crypto.randomUUID when available.
  const c = (globalThis as unknown as { crypto?: Crypto }).crypto;
  if (c && typeof c.randomUUID === "function") {
    return c.randomUUID();
  }
  // Fallback.
  return (
    Math.random().toString(36).slice(2, 10) +
    Date.now().toString(36)
  );
}
